module.exports = __webpack_public_path__ + "img/couples-025.286e23aa.jpg";